<template lang="pug">
strong Add component!
</template>

<script>
export default {
  name: "empty-component",
};
</script>